import React from 'react';
import MuiTextField from '@mui/material/TextField';
import { useTheme } from '@mui/material/styles';

export default function TextField(props) {
    const { value, required, requiredComplete, slotProps, sx, ...otherProps } = props;
    const theme = useTheme();

    // Only control value if explicitly passed (not undefined)
    // When used with Autocomplete's renderInput, value is undefined
    // and should not be controlled (Autocomplete manages it via inputProps)
    const valueProps = value !== undefined ? { value: value ?? '' } : {};

    // Build sx with asterisk styling and font size to match FormControl (0.8rem)
    const baseSx = {
        '& .MuiInputBase-input': { fontSize: '0.8rem' },
        '& .MuiInputLabel-root': { fontSize: '0.8rem' },
    };
    const asteriskSx = (required || requiredComplete) ? {
        '& .MuiFormLabel-asterisk': {
            color: requiredComplete ? theme.palette.error.main : theme.palette.primary.main,
        },
    } : {};

    return (
        <MuiTextField
            {...otherProps}
            {...valueProps}
            variant={props.variant ?? 'standard'}
            required={required || requiredComplete}
            slotProps={slotProps}
            sx={{ ...baseSx, ...sx, ...asteriskSx }}
        />
    )
}